import React, { useEffect, useState } from 'react'
import "./accordion.css"
import { ExpandMore, ExpandMoreRounded } from '@mui/icons-material';

export const AccordionComponent = ({ title = "Title required", chipsFilters = "", arrowPosition = "right", changeOpen = true  , style="" , children, hideToggle }) => {

    const [isOpen, setIsOpen] = useState(changeOpen);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };


    useEffect(()=>{
        setIsOpen(changeOpen)
    } , [
        changeOpen
    ]);

    // useEffect(()=>{
    //     // setIsOpen(extOpen);
    // },[extOpen])

    return (
        <div className={`accordion ${style}`}>
            {!hideToggle && <div className="accordion-header">
                <section>
                    <h2>{title}</h2>
                    <div className='cont-chipsFilters'>
                        {
                            chipsFilters
                        }
                    </div>
                </section>
                <span style={{
                    right : arrowPosition == "right" ? "0" : "82%"
                }} className={`accordion-icon ${isOpen ? 'open' : ''}`}  onClick={toggleAccordion}>
                    <ExpandMoreRounded sx={{
                        fontSize : "calc(var(--p-size) + 1.5rem)"
                    }}></ExpandMoreRounded>
                </span>
            </div>}
            <div className={`accordion-content ${isOpen ? 'open' : ''}`}>
                {
                    isOpen ? children : null
                    // children
                }
            </div>
        </div>
    )
}
